import htmlparser from "htmlparser2";
import { findKey, isEmpty, isString, matches } from "lodash";

const last = array =>
  array == null || array.length < 1 ? void 0 : array[array.length - 1];

export default agency => {
  const state = {
    context: [],
    expectText: false
  };
  const result = {
    data: {},
    affiliations: [],
    addresses: [],
    role: {}
  };
  let address;
  let role = {};
  new htmlparser.Parser(
    {
      onopentag: (name, attrs) => {
        if (name === "Organization") {
          result.attrs = attrs;
        }
        if (last(state.context)?.tag === "Organization") {
          if (name === "DataItem") {
            result.data[attrs.name] = attrs.value;
          }
          if (name === "Affiliation") {
            result.affiliations.push(attrs);
          }
        }
        if (name === "Address") {
          address = attrs;
        }
        if (last(state.context)?.tag === "Address") {
          address[name] = "";
        }

        if (name === "Role") {
          role = attrs;
        }
        if (
          findKey(state.context, matches({ tag: "Role" })) &&
          name === "DataItem"
        ) {
          // If we are in the Role tag, and no DataItems have been added, add an empty object
          if (!role.dataItems) role.dataItems = {};

          // If the last context is a DataItem, we are inside a nested DataItem
          if (last(state.context)?.tag === "DataItem") {
            role.dataItems[last(state.context).attrs.name][attrs.name] =
              attrs.value;
          } else {
            // Otherwise, we are still in the Role context
            if (attrs.value) {
              // If there is a value, set this item to that value
              role.dataItems[attrs.name] = attrs.value;
            } else {
              // If value is empty, this is either an empty parent tag, or we just have an empty string
              role.dataItems[attrs.name] = {};
            }
          }
        }

        state.context.push({ tag: name, attrs });
      },
      ontext: text => {
        if (!text) return;
        const lastContext = last(state.context);
        const secondLast = state.context[state.context.length - 2];
        if (["Name"].includes(lastContext?.tag)) {
          // collapse whitespace
          result[lastContext?.tag] = text.replace(/\s+/g, " ").trim();
        }
        if (["DoingBusinessAs"].includes(lastContext?.tag)) {
          result.dba = text.replace(/\s+/g, " ").trim();
        }
        if (secondLast?.tag === "Address" && lastContext?.tag) {
          address[lastContext?.tag] = text;
        }
      },
      onclosetag: name => {
        if (name === "Address") {
          result.addresses.push(address);
        }
        if (name === "Role") {
          result.role = role;
        }
        if (name === "DataItem") {
          // we want to check if this tag has an empty object as it's value (if it's nested in Role)
          // if it does, we want to just set the value to be an empty string, there are no children
          // but how
          if (findKey(state.context, matches({ tag: "Role" }))) {
            // this tag is nested somewhere in roles
            const lastContext = last(state.context);
            const secondLast = state.context[state.context.length - 2];
            if (
              secondLast?.tag === "DataItem" &&
              lastContext?.tag === "DataItem"
            ) {
              // if the second to last context was DataItem, and this is DataItem...
              if (
                !isString(
                  role.dataItems[secondLast.attrs.name][lastContext.attrs.name]
                ) &&
                isEmpty(
                  role.dataItems[secondLast.attrs.name][lastContext.attrs.name]
                )
              ) {
                role.dataItems[secondLast.attrs.name][lastContext.attrs.name] =
                  "";
              }
            } else if (lastContext?.tag === "DataItem") {
              if (
                !isString(role.dataItems[lastContext.attrs.name]) &&
                isEmpty(role.dataItems[lastContext.attrs.name])
              ) {
                role.dataItems[lastContext.attrs.name] = "";
              }
            }
          }
        }
        // remove the last context, that tag closed
        state.context.pop();
      }
    },
    { xmlMode: true, decodeEntities: true }
  ).end(agency);
  return result;
};
